import { CreateControleAcessoDto } from "../shared/dtos/ControleAcesso.dto";
import { CreateUserDto, GetUserDto, UpdateUserDto } from "../shared/dtos/Usuario.dto";
import api from "./api"; // Sua instância de Axios

// Classe de serviço para lidar com requisições relacionadas a usuários
class UserService {


  async register(userData: CreateUserDto, controleAcesso: CreateControleAcessoDto[]) {
    const data = {
      userData: userData,
      controleAcesso: controleAcesso
    }
    return api.post("/user/register", data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.error("Erro ao registrar:", error.response ? error.response.data : error.message);
        return Promise.reject(error);
      });
  }

  // Método para buscar todos os usuários
  async getAllUsers(): Promise<GetUserDto[]> {
    return api
      .get("/user/getAll")
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.error(
          "Erro ao buscar usuários:",
          error.response ? error.response.data : error.message
        );
        return Promise.reject(error);
      });
  }

  // Método para atualizar um usuário
  async updateUser(id: number, updateUserDto: UpdateUserDto, controleAcesso: CreateControleAcessoDto[]): Promise<void> {
    const data = {
      updateUserDto,
      controleAcesso
    };
    return api.patch(`/user/update/${id}`, data)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.error("Erro ao atualizar usuário:", error.response ? error.response.data : error.message);
        return Promise.reject(error);
      });
  }


  async softDeleteUser(id: number): Promise<void> {
    return api.delete(`/user/delete/${id}`)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.error("Erro ao excluir usuário:", error.response ? error.response.data : error.message);
        return Promise.reject(error);
      });
  }

  async resetPassword(id: number): Promise<void> {
    return api.post(`/user/reset-password/${id}`)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.error("Erro ao resetar senha:", error.response ? error.response.data : error.message);
        return Promise.reject(error);
      });
  }

  async changePassword(id: number, currentPassword: string, newPassword: string): Promise<void> {
    return api.post(`/user/password/${id}`, {
      currentPassword: currentPassword,
      newPassword: newPassword
    })
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        console.error("Erro detalhado ao alterar senha:", {
          error,
          response: error.response,
          data: error.response?.data,
          status: error.response?.status
        });
        return Promise.reject(error);
      });
  }

}

// Exporta uma instância do UserService
const userService = new UserService();
export default userService;
